var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"council-report-component"},[_c('vue-form',{ref:"form",attrs:{"options":{ permalink: 'generateCouncilReport' }}},[_c('div',{staticClass:"card-header",attrs:{"slot":"title"},slot:"title"},[_vm._v("Generate Report")])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2f649fba","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/CouncilReport.vue
// module id = 1138
// module chunks = 1